<template></template>

<script>
    export default {
        name: "Signup"
    }
</script>

<style scoped>
</style>